<template>
  <div class="content-wrapper">
    <!-- Aside Bar -->
    <AsideBar />
    <!-- Content Header -->
    <section class="content-header">
      <div style="border-bottom: 1px solid #00000017; height: 75px">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Audience Creator</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Dashboard' }"
                >Dashboard</router-link
              >
              <li class="breadcrumb-item active">Audience Creator</li>
            </ol>
          </div>
          <div class="col-sm-6 text-right" v-if="isCreatingAvailable">
            <router-link
              tag="button"
              :to="{ name: 'Audience Create' }"
              class="btn btn-color--primary m-0"
            >
              Create Audience
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- Table -->
    <v-app class="mt-0 m-4">
      <v-card>
        <v-card-title class="table-card-header--color pl-0">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            class="table-search-field--width ml-2"
            single-line
            hide-details
            solo
            dense
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="audience"
          sort-by="id"
          :sort-desc="true"
          class="elevation-1"
          @click:row="handleClick"
          single-select
          :search="search"
          :loading="loading"
          loading-text="Loading Audience ..."
          :footer-props="{
            'items-per-page-options': [10, 25, 50],
          }"
        >
          <transition-group
            class="list-group"
            name="fruit-list"
            tag="table"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated  animate__fadeOut animate__faster"
          >
            <tbody name="list" is="transition-group" v-show="audience">
              <tr v-for="(row, index) in audience" class="ttrow" :key="index">
                <td>
                  <div>{{ row.id }}</div>
                </td>
                <td>
                  <div>{{ row.name }}</div>
                </td>
                <td>
                  <div>{{ row.id }}</div>
                </td>
              </tr>
            </tbody>
          </transition-group>
          <!-- <template v-slot:[`item.action_count`]>
            <button
              class="btn btn-sm btn-warning m-0 mr-2 font-size-13"
              style="width: fit-content"
            >
              Audience Count
            </button>
          </template> -->
          <template v-slot:[`item.actions`]="{ item }">
            <!-- <slot></slot> -->
            <audience-count-button
              :websiteId="website_id"
              :query="[item.query !== null ? item.query : {}]"
            >
              <template #audience-button-title="{ title }">
                {{ title }}
              </template>
            </audience-count-button>
            <!-- <button
              :key="item.id"
              class="btn btn-sm btn-warning m-0 mr-2 font-size-13"
              style="min-width: 30px; height: 30px"
              @click="getAudCount(item.query, item, $refs, $el)"
            > -->
            <!-- <div
                v-if="audCountLoading && !item.count"
                class="spinner-border"
                style="height: 14px; width: 14px"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div> -->
            <!-- <p>{{ item.count ? item.count : "Count" }}</p>
            </button> -->
            <router-link
              class="m-0 mr-2"
              :to="{
                name: 'ViewAud',
                params: { seg_id: item.id, obj: item, type: 'audience' },
              }"
            >
              <v-btn dark small color="primary"> Visualize Audience </v-btn>
            </router-link>
            <router-link
              :to="{
                name: 'Edit Audience',
                params: { aud_id: item.id, obj: item },
              }"
              class="m-0 ml-5 mr-2"
              v-if="isEditingAvailable"
            >
              <v-btn dark small color="success">
                <v-icon dark small> mdi-pencil </v-icon>
              </v-btn>
            </router-link>
            <v-btn
              class="m-0 mr-2"
              @click="
                id = item.id;
                shwQuestion = true;
              "
              dark
              small
              color="error"
            >
              <v-icon dark small> mdi-trash-can-outline </v-icon>
            </v-btn>
            <!-- <button
              class="btn btn-sm btn-light m-0 mr-2 font-size-13"
              style="width: fit-content"
              @click="
                id = item.id;
                shwQuestion = true;
              "
            >
              Delete
            </button> -->
          </template>
        </v-data-table>
      </v-card>
    </v-app>
    <!-- Error -->
    <Error v-if="error" :error="error" />
    <Question
      v-if="shwQuestion"
      @didClose="shwQuestion = false"
      @confirmed="deleteSegment(id)"
      @notConfirmed="shwQuestion = false"
      title="Are you sure?"
      text="You will delete this audience filter and won't be able to restore it."
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
      isConfirmedTitle="Deleted!"
      isConfirmedText="Your audience filter has been deleted!"
      dismissTitle="Cancelled!"
      dismissText="Your audience filter is in the safe :)"
      confirmButtonClasses="btn btn-success"
      cancelButtonClasses="btn btn-danger"
      successIcon="success"
      errorIcon="error"
    />
  </div>
</template>

<script>
//import "../../assets/styles/main.css";
//import AsideBar from "../websiteDash/AsideBar.vue";
import Segments from "../../apis/Segments.js";
import Domains from "../../apis/Domains.js";
import Error from "../popUps/Error.vue";
import AudienceCountButton from "./AudienceCountButton.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import Question from "../popUps/Question.vue";

export default {
  // Name
  name: "AudienceCreator",
  // Components
  components: {
    AsideBar: () => import("../websiteDash/AsideBar.vue"),
    AudienceCountButton,
    Error,
    Question,
  },
  // Data
  data() {
    return {
      shwQuestion: false,
      website_id: "",
      limit: 1000,
      offset: 0,
      audCountLoading: false,
      // For Data Table
      loading: true,
      offset: 0,
      search: "",
      totalLength: null,
      page: null,
      itemsPerPage: null,
      id: null,
      headers: [
        // { text: "#", value: "id" },
        {
          text: "Id",
          value: "id",
          divider: true,
          class: "table-header--color",
        },
        {
          text: "Name",
          value: "name",
          align: "left",
          divider: true,
          class: "table-header--color",
        },
        // { text: "Subscribers", value: "id", align: "center" },
        {
          text: "",
          value: "action_count",
          sortable: false,
          align: "center",
          class: "table-header--color",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "center",
          divider: true,
          class: "table-header--color",
        },
      ],
    };
  },
  // Computed
  computed: {
    // Map State
    ...mapState({
      // Audience Records
      audience: (state) => state.segment.segments,
      // Error
      error: (state) => state.segment.errorSegment,
    }),
    ...mapGetters(["permissions"]),

    isCreatingAvailable() {
      return this.permissions.includes("audience_create");
    },
    isEditingAvailable() {
      return this.permissions.includes("audience_edit");
    }
  },
  // Mounted
  mounted() {
    Domains.show("/" + this.$route.params.id).then((response) => {
      this.website_id = response.data.data[0].website_id;
    });
    // Get Audience Recorda
    this.obtainAudience();
    // this.getSegments(
    //   `?where[type]=audience&where[domain_id]=${this.$route.params.id}&where[is_system]=0`
    //   //`?where[type]=audience&where[domain_id]=${this.$route.params.id}`
    // );
    // .then(() => {
    //   this.loading = false;
    // })
    // .catch(() => {
    //   this.loading = false;
    // });
    // Empty Array After Clicking Back Button
    window.addEventListener("popstate", () => {
      this.$store.state.segment.segments = [];
    });
  },
  // Methods
  methods: {
    // Get Audience Records
    // ...mapActions({
    //   // Get Audience Records
    //   getSegments: "getSegments",
    //   // Delete Audience
    //   deleteSegment: "deleteSegment",
    // }),
    ...mapActions(["getSegments", "deleteSegment"]),
    getAudCount(query, item, on, el) {
      Segments.getAudCount(this.website_id, query)
        .then((response) => {
          let count = response.data.data.length;
          let index = this.audience.findIndex((obj) => {
            return obj.id == item.id;
          });

          this.$store.state.segment.segments[index]["count"] = count;
        })
        .catch(() => {});
    },
    obtainAudience() {
      this.getSegments(
        `?where[type]=audience&where[domain_id]=${this.$route.params.id}&where[is_system]=0&limit=1000&offset=${this.offset}`,
        //`?group_by=group_id&with[schedules]=*&where[domain_id]=${this.$route.params.id}`
      ).then((response) => {
        if (response.data.data.length === 1000) {
          this.offset += 1000;
          this.obtainAudience();
        }
      });
    },
    // Handle Click
    handleClick(item, row) {
      row.select(true);
      item.selected = item;
    },
  },
  // Watch
  watch: {
    // Route Name
    "$route.name": {
      handler() {
        this.$store.state.segment.segments = [];
      },
      deep: true,
      immediate: true,
    },
    // Error
    error() {
      if (this.error) {
        this.loading = false;
      }
    },
    // Audience Records
    audience() {
      if (this.audience || !this.audience || this.error) {
        this.loading = false;
      }
    },
  },
};
</script>
